import { useEffect, useState } from "react";
import { matchPath, useLocation, useNavigate } from "react-router-dom";

// components
import { Divider } from "@mui/material";
import WishlinkDrawer from "WishlinkComponents/WishlinkDrawer";
import WishlinkTypography from "WishlinkComponents/WishlinkTypography";

// utils
import { getAssetUrl } from "utils/common";
import {
  GA_ACTION,
  GA_CATEGORIES,
  GA_SCREEN_NAME,
  PAGE_URLS,
} from "utils/constants";
import { triggerGa } from "utils/gaUtils";

const InstaLoginInfoDrawer = () => {
  const [showInstaDrawer, setShowInstaDrawer] = useState(false);
  const [engagePermissionsValidated, setEngagePermissionsValidated] =
    useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.state?.showDrawer) {
      // don't show on kyc page for new user + only appear for partial login
      if (matchPath(location.pathname, PAGE_URLS.KYC)) {
        if (location.state?.engage_permissions_validated === false) {
          // storing to show on home page later only if permission not given
          localStorage.setItem("showInstaInfoDrawer", "true");
        }
        setShowInstaDrawer(false);
      } else {
        setShowInstaDrawer(true);
        setEngagePermissionsValidated(
          location.state?.engage_permissions_validated
        );
      }
    }
  }, [location.state]);

  useEffect(() => {
    if (location.pathname === PAGE_URLS.HOME) {
      const showInstaInfoDrawer = localStorage.getItem("showInstaInfoDrawer");
      // show on home page and it will only appear for partial login
      if (showInstaInfoDrawer === "true") {
        setShowInstaDrawer(true);
        setEngagePermissionsValidated(false);
      }
    }
  }, [location.pathname]);

  const handleClose = () => {
    // clear location.state after use
    navigate(location.pathname + location.hash, { replace: true, state: {} });
    localStorage.removeItem("showInstaInfoDrawer");
    setShowInstaDrawer(false);
  };

  const handleContinue = () => {
    triggerGa({
      category: GA_CATEGORIES.NAVIGATION,
      action: GA_ACTION.BUTTON_CLICK,
      label: location.pathname,
      label2: "Continue",
      label3: engagePermissionsValidated ? "complete" : "partial",
      page: location.pathname,
      screenName: GA_SCREEN_NAME.IG_LOGIN_PERMISSION_DRAWER,
    });
    handleClose();
  };

  const handleNavigationEngage = () => {
    triggerGa({
      category: GA_CATEGORIES.NAVIGATION,
      action: GA_ACTION.BUTTON_CLICK,
      label: "EngageProps",
      label2: "partial",
      page: location.pathname,
      screenName: GA_SCREEN_NAME.IG_LOGIN_PERMISSION_DRAWER,
    });
    setShowInstaDrawer(false);
    // clear location.state after use
    navigate(location.pathname, { replace: true, state: {} });
    localStorage.removeItem("showInstaInfoDrawer");
    navigate(PAGE_URLS.ENABLEENGAGE);
  };

  return (
    <WishlinkDrawer drawerOpen={showInstaDrawer} onClose={handleClose}>
      <div
        className="flex"
        style={{ flexDirection: "column", padding: "1rem", gap: "1rem" }}
      >
        {engagePermissionsValidated ? <CompleteSetup /> : <PartialSetup />}

        <div
          className="flex"
          style={{
            borderRadius: "1.25rem",
            background: "#E91E63",
            padding: "0.75rem 1rem",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
            boxShadow: `0px 4px 4px 0px rgba(0, 0, 0, 0.25)`,
          }}
          onClick={handleContinue}
        >
          <WishlinkTypography
            fontSize="0.875rem"
            color={"#FFF"}
            fontWeight={600}
            textAlign={"left"}
            mr="0.62rem"
          >
            Continue
          </WishlinkTypography>
          <img src={getAssetUrl("arrow-leading-icon.svg")} alt="leading-icon" />
        </div>
        {!engagePermissionsValidated && (
          <div
            className="flex"
            style={{
              borderRadius: "1.25rem",
              border: ` 1px solid #E91E63`,
              background: "#FFF",
              padding: "0.75rem 1rem",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
              boxShadow: `0px 4px 4px 0px rgba(0, 0, 0, 0.25)`,
            }}
            onClick={handleNavigationEngage}
          >
            <WishlinkTypography
              fontSize="0.875rem"
              color={"#E91E63"}
              fontWeight={600}
              textAlign={"left"}
              mr="0.62rem"
            >
              Activate Engage
            </WishlinkTypography>
            <img
              src={getAssetUrl("arrow-leading-icon-default.svg")}
              alt="leading-icon"
            />
          </div>
        )}
      </div>
    </WishlinkDrawer>
  );
};

export default InstaLoginInfoDrawer;

const PartialSetup = () => {
  return (
    <div>
      <div
        className="flex align-center"
        style={{
          flexDirection: "column",
          gap: "1.25rem",
          marginTop: "1.25rem",
          marginBottom: "1rem",
        }}
      >
        <img
          src={getAssetUrl("partial-emoji.png")}
          alt="partial-emoji"
          style={{
            height: "2.5rem",
            width: "2.5rem",
          }}
        />
        <WishlinkTypography
          fontSize="0.875rem"
          color={"#000"}
          fontWeight={600}
          textAlign="center"
        >
          Setup Partially Successful
        </WishlinkTypography>
        <WishlinkTypography
          fontSize="0.75rem"
          color={"#000"}
          fontWeight={400}
          textAlign="center"
        >
          Some permissions are missing. You can still create Wishlinks, but
          Engage (Auto DMs) won’t work yetTo enable this feature, visit the
          Engage page and complete the setup
        </WishlinkTypography>
        <Divider sx={{ borderStyle: "dashed", width: "100%" }} />
      </div>
      <WishlinkTypography
        fontSize="0.75rem"
        color={"#000"}
        fontWeight={400}
        textAlign="left"
        mb="1rem"
      >
        You have partially completed the Login, you can
      </WishlinkTypography>
      <WishlinkTypography
        fontSize="0.75rem"
        color={"#000"}
        fontWeight={500}
        textAlign="left"
        mb="0.25rem"
      >
        What’s working?
      </WishlinkTypography>
      <div className="flex" style={{ marginBottom: "1.25rem" }}>
        <img src={getAssetUrl("right-green-icon.svg")} alt="right-green-icon" />
        <WishlinkTypography
          fontSize="0.75rem"
          color={"#000"}
          fontWeight={400}
          textAlign="left"
          ml="0.5rem"
        >
          Create Wishlinks – Add and share product links
        </WishlinkTypography>
      </div>

      <WishlinkTypography
        fontSize="0.75rem"
        color={"#000"}
        fontWeight={500}
        textAlign="left"
        mb="0.25rem"
      >
        What’s not working?
      </WishlinkTypography>
      <div className="flex align-start">
        <img
          src={getAssetUrl("close-red-icon.svg")}
          alt="close-red-icon"
          style={{ marginTop: "0.15rem" }}
        />
        <WishlinkTypography
          fontSize="0.75rem"
          color={"#000"}
          fontWeight={400}
          textAlign="left"
          ml="0.5rem"
        >
          Wishlink Engage (Auto DMs) – Auto-replies are not active.
        </WishlinkTypography>
      </div>
    </div>
  );
};

const CompleteSetup = () => {
  return (
    <div>
      <div
        className="flex align-center"
        style={{
          flexDirection: "column",
          gap: "1.25rem",
          marginTop: "1.25rem",
          marginBottom: "1rem",
        }}
      >
        <img
          src={getAssetUrl("complete-emoji.png")}
          alt="complete-emoji"
          style={{
            height: "2.5rem",
            width: "2.5rem",
          }}
        />
        <WishlinkTypography
          fontSize="0.875rem"
          color={"#000"}
          fontWeight={600}
          textAlign="center"
        >
          Your Setup is Complete!
        </WishlinkTypography>
        <WishlinkTypography
          fontSize="0.75rem"
          color={"#000"}
          fontWeight={400}
          textAlign="center"
        >
          Your Instagram is connected, and Wishlink Engage (Auto DMs) is now
          active. You’re all set to create wishlinks and automate product link
          replies.
        </WishlinkTypography>
        <Divider sx={{ borderStyle: "dashed", width: "100%" }} />
      </div>
      <WishlinkTypography
        fontSize="0.75rem"
        color={"#000"}
        fontWeight={500}
        textAlign="left"
        mb="0.25rem"
      >
        What’s enabled?
      </WishlinkTypography>
      <div className="flex align-start" style={{ marginBottom: "0.5rem" }}>
        <img
          src={getAssetUrl("right-green-icon.svg")}
          style={{ marginTop: "0.15rem" }}
          alt="right-green-icon"
        />
        <WishlinkTypography
          fontSize="0.75rem"
          color={"#000"}
          fontWeight={400}
          textAlign="left"
          ml="0.5rem"
        >
          Create Wishlinks – Add and share products effortlessly
        </WishlinkTypography>
      </div>
      <div className="flex align-start">
        <img
          src={getAssetUrl("right-green-icon.svg")}
          style={{ marginTop: "0.15rem" }}
          alt="right-green-icon"
        />
        <WishlinkTypography
          fontSize="0.75rem"
          color={"#000"}
          fontWeight={400}
          textAlign="left"
          ml="0.5rem"
        >
          Engage (Auto DMs) – Automatically reply to product link requests
        </WishlinkTypography>
      </div>
      <WishlinkTypography
        fontSize="0.75rem"
        color={"#000"}
        fontWeight={400}
        textAlign="left"
        mt="1rem"
      >
        You’re ready to go!
      </WishlinkTypography>
    </div>
  );
};
